import { EllipsisTextContainer } from './EllipsisText.styles'

interface EllipsisTextProps {
  value?: string | null
}

const EllipsisText = ({ value }: EllipsisTextProps) => {
  const displayValue = value?.trim() ? value : '-'

  if (displayValue === '-') {
    return <>{displayValue}</>
  }

  return (
    <EllipsisTextContainer component="span">
      {displayValue}
    </EllipsisTextContainer>
  )
}

export default EllipsisText
